import { MODAL_NAMES } from '@/consts';

const getters = {
  isSessionExpiredModalActive: (state) => (state.activeModals.indexOf(MODAL_NAMES.SESSION_EXPIRED) >= 0),
  isPaymentReminderClientDetailsModalActive: (state) => (state.activeModals.indexOf(MODAL_NAMES.PAYMENT_REMINDER_CLIENT_DETAILS) >= 0),
  isConfirmModalActive: (state) => (state.activeModals.indexOf(MODAL_NAMES.CONFIRM) >= 0),
  isEditOrderModalActive: (state) => (state.activeModals.indexOf(MODAL_NAMES.EDIT_ORDER) >= 0),
  isEditClientModalActive: (state) => (state.activeModals.indexOf(MODAL_NAMES.EDIT_CLIENT) >= 0),
  isOrderNoteModalActive: (state) => (state.activeModals.indexOf(MODAL_NAMES.ORDER_NOTE) >= 0),
  isEditAssetModalActive: (state) => (state.activeModals.indexOf(MODAL_NAMES.EDIT_ASSET) >= 0),
};

export default getters;
